export default __webpack_public_path__ + "static/media/invoiage_logo_only.e09c3ed1.png";